import { api } from './apiClient';
import { SubscriptionInfo, SubscriptionPlan, SubscriptionStatus } from '../types';

type BillingSnapshot = {
  email: string;
  trialStartDate: string | null;
  trialEndDate: string | null;
  subscriptionStatus: 'TRIAL' | 'ACTIVE' | 'EXPIRED' | 'CANCELED';
  subscriptionEndDate: string | null;
};

export type PlanDto = {
  id: string;
  code: string;
  name: string;
  interval: string;
  stripePriceId: string | null;
};

export function fetchSubscriptionStatus(): Promise<BillingSnapshot> {
  return api.get<BillingSnapshot>('/subscriptions/check-status');
}

export function fetchPlans(): Promise<PlanDto[]> {
  return api.get<PlanDto[]>('/subscriptions/plans', { skipAuth: true });
}

export function mapBillingToSubscriptionInfo(billing: BillingSnapshot): SubscriptionInfo {
  const now = new Date().toISOString();
  const trialEnd = billing.trialEndDate ?? now;
  const subEnd = billing.subscriptionEndDate ?? trialEnd;

  if (billing.subscriptionStatus === 'TRIAL') {
    return {
      plan: SubscriptionPlan.FREE_TRIAL,
      status: SubscriptionStatus.TRIAL,
      startDate: billing.trialStartDate ?? now,
      endDate: trialEnd,
      trialStartDate: billing.trialStartDate ?? now,
      trialEndDate: trialEnd,
      isAutoRenew: false,
    };
  }

  if (billing.subscriptionStatus === 'ACTIVE') {
    return {
      plan: SubscriptionPlan.MONTHLY,
      status: SubscriptionStatus.ACTIVE,
      startDate: now,
      endDate: subEnd,
      trialStartDate: billing.trialStartDate ?? undefined,
      trialEndDate: billing.trialEndDate ?? undefined,
      isAutoRenew: true,
    };
  }

  return {
    plan: SubscriptionPlan.FREE_TRIAL,
    status: SubscriptionStatus.EXPIRED,
    startDate: billing.trialStartDate ?? now,
    endDate: trialEnd,
    trialStartDate: billing.trialStartDate ?? now,
    trialEndDate: trialEnd,
    isAutoRenew: false,
  };
}
